import image from '../assets/placeholder.svg'

export const DEFAULT_IMG = image

export enum AltType {
  LOCATION = 'location',
}
export const recaptchaSitekey = import.meta.env.VITE_RECAPTCHA_SITEKEY ?? '6LfcbMseAAAAAI-EJoB-lUh7_TJaYloLbcbmnhEO'

// Cloudflare Turnstile site keys (paired with backend secrets in env).
const isProductionEnv = import.meta.env.MODE === 'production'
export const TURNSTILE_INVISIBLE_SITE_KEY = isProductionEnv
  ? '0x4AAAAAACCpVlau-4k7cJ33'
  : '0x4AAAAAACCpVlau-4k7cJ33'
export const TURNSTILE_VISIBLE_SITE_KEY = isProductionEnv
  ? '0x4AAAAAACDfuwSBQ2sYO1VD'
  : '0x4AAAAAACDfuwSBQ2sYO1VD'

// Cloudflare-published dummy sitekeys that always pass — used for bypassed locations
// (automation accounts, internal demo locations) so QA can drive flows without solving challenges.
export const TURNSTILE_INVISIBLE_TEST_SITE_KEY = '1x00000000000000000000BB'
export const TURNSTILE_VISIBLE_TEST_SITE_KEY = '1x00000000000000000000AA'

// Mirrors leadgen-marketplace-backend `captchaBypassLocations`. Backend will set
// `bypassCaptcha = true` for these locationIds via `isWhitelistedLocations` middleware,
// so the frontend uses dummy sitekeys to skip the challenge UI for the same locations.
export const CAPTCHA_BYPASS_LOCATIONS: string[] = isProductionEnv
  ? [
      'hk9aJw1NxnORXlvWt0Ch',
      'mUDcRUovdoUcpO2lEfCp',
      'Hrcd6b9HP6kUiNZpKvBZ',
      'stQOKSXUP1qmG46bISPI',
      'CvJTCIAeD6yENqw2xZyX',
      'UJW3IPth293NRKn2WXV7',
      'iaf5Ts9ZiICjmhN0ZouI',
      'e6MzEFPyZfu1HWjmogmX',
      'yDtSPl9VMqMc1zXSuB16',
      'gosAyw8ZrbuzTVXgaaBh',
      'OMzKNpBUbMwfWzsiHzde',
      'of59zQKG1a4D3XRgy73l',
      'RQC3BzSUBwWt4oAMiUJZ',
      'KukvaaXB9hzZKBSA24hJ',
      'G9j4K5OV2WKVMy3cfpnl',
      'XKqwP4GjV67weTkG7bAs',
      'wMz4iCyhuUxLkdL328Uy',
      'nNwhmkOYrvIwMIKfdavQ',
      'sKP3xzdQOSXYbpWrLawx',
      'w3sjjx7tonWgfguffor2',
      'JBom3DI0SuIXgndrPR5z',
      'i4cNxYXwFbEv3xflI1uX',
      'nlQH5G6z9XKypri0WRQ4',
      'lUYGRLcKpcnc2tK9w7AF',
    ]
  : [
      'jVFIxsMY19D94nOSIOEO',
      'MTyNWIWm5jWetBx13Gma',
      'MiPIXygUE1Kz0LwolHDu',
      'bKOXQvENImG83B0atykd',
      'kzlP5isP6JSx50f7s8IZ',
      'YicJNTXTvDNqKpzJAtsZ',
      'gPmPUzaEXra7eVSiCStl',
      'bKzHfeinK5RnKwN80gOE',
      'Iigsk7lnJ4nJWZBtb9Zd',
      'jAkqd5q4bewhQJr1mZZn',
      'LuXWw6oBi2TXMSSCJbI2',
      'ZN2Ye3dXSy8KRc1Z5A8m',
      '30qybSLe8OdfO5Qblplr',
      'ttczyZQq8Yor3ydwZWAk',
      '81EEeS68eQR1o82I23ft',
      '1onWxrTQzcJVV5WOn3cb',
      'G30ccfXCq6lX26Z2De4l',
      'imn9NekHcrIMRpJYmNQC',
      'oeTvUHtfkEopctDG9afC',
      'IsuhvOkLtNqiPzw9RibY',
      'qyUemSADwyTx7zDYnFc0',
      'EKhHDPXOfyrUu8goWQax',
      '6k95nOxv8M6FjhiHNuWs',
      'OT98YllMQCq02xeeEq9q',
      'r47GTd22o4SobRRauMk5',
      'LufWAfxkt1KsAaDNZa1j',
      'VKIZo2MwqmDQbhVR7qUs',
      'KVQJE1mOLGoESeGVwDCl',
      'NitqzK9VGOtSNCQPgHjF',
      'mPoT4zsYexs2ZmNFcl9D',
      'gdoKO2eCIXzP8pqZvCvv',
      'OvOEC5DacDIjzPDB5mOB',
      'th0TDtrXqpRSmSEUmCL0',
      'DSEQEokUwrA1TPc87aIo',
      'gpv2GOwr8pzVC5P6tjlk',
      'bcl7BjrtMvywL7fsGO0O',
      'G6gRYBqZ78IBzgUEuK2r',
      '36Pz3IkBFzUBbeTmn58m',
      'CC9I8nrcYdbtFbRJI3IF',
      '19LhYaQhD1m3jASwzCia',
      'iQUkHfteBWcH2XCgyeLE',
      'BOUgxtFEGV1FWWMQpVsP',
      'cMR7zglgvwencfu5vYBy',
      'FRlg2E28EUzaTlHusqwS',
      'ufMS2loMF4rIWnllTbkv',
      '19cVamW9c9EXN0Kj1Pot',
      'WcEwUrV9GX0nylaL9p0u',
      'm5NDoHViRIH3LWTLawvB',
      'htoma6IHn96hVzvYRLwq',
      'gUtoS8w6DF026ugPU3fH',
      'OTIs3P0QHk390RFoZPjf',
    ]

export const TURNSTILE_TYPE = {
  INVISIBLE: 'invisible',
  NORMAL: 'normal',
} as const
export type TurnstileType = (typeof TURNSTILE_TYPE)[keyof typeof TURNSTILE_TYPE]

// Cloudflare Turnstile `action` param — attached to the widget render call so
// server-side siteverify can validate token provenance per endpoint. Mirrors
// the `TURNSTILE_ACTION` pattern used in builder-preview (`ecomm-checkout`,
// `ecomm-product-review`, `ecomm-upsell`) to keep action naming consistent
// across the ecommerce surfaces.
export const TURNSTILE_ACTION = {
  /** Ecommerce Customer Access Center login — /generate-otp */
  ECOMM_CAC_LOGIN: 'ecomm-cac-login',
} as const
export type TurnstileAction = (typeof TURNSTILE_ACTION)[keyof typeof TURNSTILE_ACTION]

export enum LoginStrategy {
  OTP = 'otp',
}

export const DefaultProductImage = 'https://stcdn.leadconnectorhq.com/funnel/store/default-product-image.svg'
